import React, { Fragment } from "react";
import {
  ViedocMenuItemElement,
  ViedocSelectElement,
} from "../../../../secure/elements/ViedocReactElements";
import { useDispatch, useSelector } from "react-redux";
import { StorageHelper } from "../../../../../utils/storageHelper";
import _ from "underscore";
import * as zoneActions from "../../../../store/actions/zoneActions";
import { useTranslation } from "react-i18next";
import APP_CONST from "../../../shared/constants";

import {getMilestoneGroupLabel, findObject} from "../../../../../utils/utilsHelper";

const DropdownFilters = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    siteList,
    milestoneGroupList,
    countryList,
    settings,
    mileStoneListWithGroup,
  } = useSelector((store) => store.template);
  const {
    selectedSiteID,
    selectedCountryID,
    selectedMilestoneID,
    countrySiteList,
  } = useSelector((store) => store.zone);

  const defaultSite = { value: "ALL", label: t("ADMIN.PLACEHOLDER_ALLSITES") };
  const defaultCountry = [
    { value: "ALL", label: t("ADMIN.TEXT_ALLDOCUMENTS") },
    { value: "Trial", label: t("ADMIN.PLACEHOLDER_TRIALLEVEL") },
  ];
  const defaultMileStone = {
    value: "ALL",
    label: t("ADMIN.PLACEHOLDER_ALLMILESTONES"),
  };

  const filterData = StorageHelper.getFilterInfo();
  const latestSiteFilter =
    !_.isEmpty(filterData) && filterData.selectedSiteID !== undefined
      ? filterData.selectedSiteID
      : selectedSiteID;
  const latestCountryFilter =
    !_.isEmpty(filterData) && filterData.selectedCountryID !== undefined
      ? filterData.selectedCountryID
      : selectedCountryID;
  const latestMileFilter =
    !_.isEmpty(filterData) && filterData.selectedMilestoneID !== undefined
      ? filterData.selectedMilestoneID
      : selectedMilestoneID;

  const countryMapping = [
    ...defaultCountry,
    ...countryList?.map((country) => ({
      value: country.countryCode,
      label: country.country,
    })),
  ];

  const modifiedSiteList = siteList?.map((siteName) => ({
    value: siteName.guid,
    label: siteName.siteName,
    countryCode: siteName.countryCode,
    country: siteName.country,
  }));

  let siteListData =
    latestCountryFilter !== "ALL"
      ? _.filter(modifiedSiteList, { countryCode: latestCountryFilter })
      : modifiedSiteList;

  let siteFilterMapping = [defaultSite, ...siteListData];
  mileStoneListWithGroup.map((milestone) => {
    if (APP_CONST.MILESTONE_GROUP_LIST.includes(milestone.label)) {
      return (milestone.label = getMilestoneGroupLabel(milestone.label));
    }
    return milestone.label;
  });

  const milestoneMapping = [defaultMileStone, ...mileStoneListWithGroup];
  const dropDownArray = [
    {
      name: "country",
      mappingValues: countryMapping,
      selectedValue: latestCountryFilter,
    },
    {
      name: "site",
      mappingValues: siteFilterMapping,
      selectedValue: latestSiteFilter,
    },
    {
      name: "milestone",
      mappingValues: milestoneMapping,
      selectedValue: milestoneGroupList?.result?.includes(latestMileFilter)
        ? `${latestMileFilter}_milestoneGroup_`
        : latestMileFilter,
    },
  ];

  const filterDataLoaded =
    !_.isEmpty(siteList) &&
    !_.isEmpty(countryList) &&
    !_.isEmpty(countrySiteList?.country) &&
    !_.isEmpty(countrySiteList?.site);

  const handleSelect = (event, name) => {
    switch (name) {
      case "country":
        if (event.target.value !== "ALL" && event.target.value !== "Trial") {
          const newSiteFilter = siteList.filter(
            (site) => site.countryCode === event.target.value
          );
          siteFilterMapping = [
            { ...defaultSite },
            ...newSiteFilter.map((siteName) => ({
              value: siteName.guid,
              label: siteName.siteName,
              countryCode: siteName.countryCode,
              country: siteName.country,
            })),
          ];
        } else if (event.target.value === "ALL") {
          siteFilterMapping = [
            { ...defaultSite },
            ...siteList.map((siteName) => ({
              value: siteName.guid,
              label: siteName.siteName,
              countryCode: siteName.countryCode,
              country: siteName.country,
            })),
          ];
        } else {
          siteFilterMapping = [defaultSite];
        }
        break;

      case "site":
        if (event.target.value !== "ALL") {
          const findCountryCode = siteFilterMapping.find(
            (site) => site.value === event.target.value
          ).countryCode;
          const newSiteFilter = siteList.filter(
            (site) => site.countryCode === findCountryCode
          );
          siteFilterMapping = [
            { ...defaultSite },
            ...newSiteFilter.map((siteName) => ({
              value: siteName.guid,
              label: siteName.siteName,
              countryCode: siteName.countryCode,
              country: siteName.country,
            })),
          ];
        }
        break;

      default:
        break;
    }
    dispatch(
      zoneActions.setFilterCountryID(
        event.target.value
          ? event.target.value.replace("_milestoneGroup_", "")
          : "",
        name
      )
    );
    dispatch(zoneActions.fetchMetricsData());
  };
  
  const dropdownSelectedValue = (dropValue) => {
    if(dropValue === "country"){
      return findObject(countryMapping, "value", latestCountryFilter)?.label;
    } else if(dropValue === "site"){
      return findObject(siteFilterMapping, "value", latestSiteFilter)?.label;
    } else {
      const milestoneSelectedData = milestoneGroupList?.result?.includes(latestMileFilter) ? `${latestMileFilter}_milestoneGroup_` : latestMileFilter;
      return findObject(milestoneMapping, "value", milestoneSelectedData)?.label;
    }
  }

  const renderDropdown = (dropValue) => {
    if (dropValue.name === "milestone" && !settings.ismilestoneenabled) {
      return;
    }
    return (
      <ViedocSelectElement
        name={dropValue.name}
        size="small"
        variant="standard"
        onChange={(event) => handleSelect(event, dropValue.name)}
        title={dropdownSelectedValue(dropValue.name)}
      >
        {dropValue.mappingValues.map((item) => (
          <ViedocMenuItemElement
            key={item.value}
            selected={item.value === dropValue.selectedValue ? true : null}
            value={item.value}
            className={
              dropValue.name === "milestone" &&
              !(
                milestoneGroupList?.result?.includes(item.value.split("_")[0])||
                item.label === t("ADMIN.PLACEHOLDER_ALLMILESTONES")
              )
                ? "menu-list-separation"
                : ""
            }
            title=""
          >
            {item.label}
          </ViedocMenuItemElement>
        ))}
      </ViedocSelectElement>
    );
  };

  return (
    <div className="zone-filter-panel">
      {filterDataLoaded && (
        <>
          {/* <div className="search">
            <viedoc-icon name="search" />
          </div> */}
          {dropDownArray.map((dropType) => (
            <Fragment key={dropType.name}>{renderDropdown(dropType)}</Fragment>
          ))}
        </>
      )}
    </div>
  );
};

export default DropdownFilters;
